import React from 'react';

type Stripe = {
  className: string;
};

export const StripeIcon: React.FC<Stripe> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 40"
    className={props.className}
  >
    <defs />
    <path
      fill="#6772E5"
      fillRule="evenodd"
      d="M65.643 8.625c4.63 0 8.996 4.18 9.022 11.854 0 8.387-4.312 12.197-9.048 12.197-2.329 0-3.731-.979-4.683-1.667l-.027 7.488-6.615 1.402V9.05h5.821l.344 1.64c.926-.846 2.593-2.064 5.186-2.064zM24.844 3.334l-.026 5.741h5.027v5.636h-5.027v9.393c0 3.915 4.18 2.698 5.027 2.354v5.371c-.873.477-2.46.874-4.63.874-3.916 0-6.853-2.884-6.853-6.8L18.39 4.71l6.455-1.376zM9.208 8.625c2.196 0 4.365.344 6.561 1.218v6.217c-2.01-1.085-4.55-1.693-6.561-1.693-1.403 0-2.25.397-2.25 1.429 0 2.963 10.081 1.56 10.108 9.445 0 4.736-3.784 7.462-9.287 7.462-2.276 0-4.763-.45-7.223-1.509v-6.297c2.222 1.217 5.027 2.117 7.223 2.117 1.481 0 2.54-.397 2.54-1.614 0-3.149-10.054-1.984-10.054-9.287 0-4.683 3.571-7.488 8.943-7.488zm76.755 0c6.27 0 9.552 5.345 9.552 12.118 0 .635-.053 2.011-.053 2.355H82.524c.29 3.122 2.566 4.022 5.132 4.022 2.62 0 4.684-.556 6.483-1.455v5.291c-1.8 1.006-4.18 1.72-7.33 1.72-6.455 0-10.953-4.022-10.953-11.986 0-6.72 3.81-12.065 10.107-12.065zm-34.131.45v23.151H45.19V9.076h6.64zm-13.758 1.958c1.56-2.857 4.656-2.275 5.503-1.958v6.086c-.82-.291-3.466-.662-5.027 1.375v15.69h-6.615V9.076h5.715zM64.056 14.5c-1.509 0-2.461.53-3.149 1.297l.027 9.816c.635.688 1.56 1.243 3.122 1.243 2.434 0 4.074-2.646 4.074-6.191 0-3.466-1.667-6.165-4.074-6.165zm21.88-.503c-1.666 0-3.492 1.244-3.492 4.234h6.826c0-2.99-1.72-4.234-3.333-4.234zM51.833.265v5.37l-6.641 1.43V1.666L51.83.265z"
    />
  </svg>
);
